/** Device class reported with events and audience hits. */
export type DeviceClass = "mobile" | "tablet" | "desktop";

/**
 * Coarse device class from the user agent (iPadOS reports a desktop UA: touch points tell it apart).
 *
 * @returns `mobile`, `tablet` or `desktop` (`desktop` on the server).
 */
export function detectDevice(): DeviceClass {
  if (typeof navigator === "undefined") return "desktop";
  const ua = navigator.userAgent;
  if (/tablet|ipad|playbook|silk/i.test(ua)) return "tablet";
  if (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) return "tablet";
  if (/android/i.test(ua) && !/mobile/i.test(ua)) return "tablet";
  if (/mobile|iphone|ipod|android|blackberry|opera mini|iemobile/i.test(ua)) return "mobile";
  return "desktop";
}

/**
 * Browser family from the user agent.
 *
 * @returns A short browser name, or `Unknown`.
 */
export function detectBrowser(): string {
  if (typeof navigator === "undefined") return "Unknown";
  const ua = navigator.userAgent;
  if (ua.includes("Firefox")) return "Firefox";
  if (ua.includes("SamsungBrowser")) return "SamsungBrowser";
  if (ua.includes("Opera") || ua.includes("OPR")) return "Opera";
  if (ua.includes("Edg")) return "Edge";
  if (ua.includes("Chrome")) return "Chrome";
  if (ua.includes("Safari")) return "Safari";
  return "Unknown";
}
